import React, { useEffect, useRef, useState } from "react";

import Header from "../../components/Header";
import { Footer } from "../../components/Footer";

const Settings2 = () => {

  <>
    <Header />
    <div className="front-end-dashboard">
      <div className="site_container">

        {/* start: dashboard-page-body */}
        <div className="dashboard-page-body">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero atque eveniet perspiciatis ad esse quidem voluptatum libero, perferendis sint temporibus consequuntur aspernatur. Facere illo quasi, ratione obcaecati asperiores illum eius.
        </div>
        {/* end: dashboard-page-body */}
      </div>
    </div >
    <Footer />
  </>
};

export default Settings2;
